import { Injectable } from '@angular/core';
import {
  CreditorIdentifier,
  PaymentRequestDto,
} from '@app/model/payment-request/payment-request.dto';
import { QueryParamsService } from '../query-params/query-params.service';

@Injectable()
export class TermsLinkService {
  constructor(private queryParamsService: QueryParamsService) {}

  SEKKI_PDF_LINK: string = 'https://cdn.zaver.com/links/latest/SE-SEKKI';
  SEKKI_FRINK_PDF_LINK: string =
    'https://cdn.zaver.com/links/latest/SE-SEKKI-FRINK';

  getSekkiLink(paymentRequest: PaymentRequestDto): string {
    const selectedPaymentMethodIdentifier =
      this.queryParamsService.getQueryParams().method;

    const selectedPaymentMethod = paymentRequest.availableMethods.find(
      (method) => method.id === selectedPaymentMethodIdentifier
    );

    if (
      selectedPaymentMethod?.creditorIdentifier === CreditorIdentifier.SE_FRINK
    ) {
      return this.SEKKI_FRINK_PDF_LINK;
    } else {
      return this.SEKKI_PDF_LINK;
    }
  }

  getTermsLink = (): string => 'https://zaver.com/terms-se/anvandarvillkor';

  getPrivacyPolicyLink = (): string =>
    'https://zaver.com/terms-se/integritetspolicy';

  getCookiePolicyLink = (): string => 'https://zaver.com/sv/cookies';
}
